import React, { useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _ from "lodash";
import { Container, Col, Row, Dropdown, Spinner, Modal, Form } from "react-bootstrap";
import DataTable from "react-data-table-component";
//import DataTableExtensions from "react-data-table-component-extensions";
//import "react-data-table-component-extensions/dist/index.css";
import { v4 as uuidv4 } from "uuid";
import FuseAttachment from "../../FuseAttachmentPicker";
import FuseCollapsiblePanel from "../../FuseCollapsiblePanel";
import { fetchGenericData, insertRecord, updateRecord, deleteRecord } from "../../../../webservices/generic/genericDataWs";
import { showDataFetchError } from "../../../../actions/generic/fuseAlerts";
import { submitChildQuery } from "../../../../actions/generic/genericPageActions";
import FuseToggleDropdown from "../../FuseToggleDropdown";
import { showAlert } from "../../../../actions/generic/alertActions";
import { addToastAction } from "../../../../actions/generic/toastActions";
import { ToastTypes } from "../../modals/FuseToast";
import FuseInputBox from "../../inputFields/FuseInputBox";
import FuseToolbar from "./../../../generic/FuseToolbar";
import FuseForm from "./../../../generic/FuseForm";
import { fuseDataTableCustomStyles } from "../../../../scss/generic/fuse-react-data-table-theme";
import OverviewPanelSearchWrapper from "./OverviewPanelSearchWrapper";
import moment from "moment";
// import { getTableAttachment } from "../../../../webservices/generic/attachmentsWs"; //now an action

class OverviewPanelDatagrid extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      originalData: [],
      isInEdit: false,
      isDirty: false,
      isFormValid: false,
      clearSelected: false,
      tableUiSelectedRows: [],
      linkedRow: null,
      key: "id"
    };
  }

  static defaultProps = {
    onPanelVisible: (panelNumber) => {},
    onPanelHidden: (panelNumber) => {},
    onIsLoading: (isLoading) => {}
  };

  conditionalRowStyles = [
    {
      when: (row) => row.isInserted === true,
      style: {
        backgroundColor: "var(--success)",
        "&:hover": { backgroundColor: "var(--success)" }
      }
    },
    {
      when: (row) => this.state.tableUiSelectedRows.includes(row) || row[this.state.key] === this.state?.linkedRow?.[this.state.key],
      style: {
        backgroundColor: "var(--info)",
        "&:hover": { backgroundColor: "var(--info)" }
      }
    },
    {
      when: (row) => row.isDeleted === true,
      style: {
        backgroundColor: "var(--danger)",
        "&:hover": { backgroundColor: "var(--danger)" }
      }
    }
    // {
    //   when: (row) => row.isInvalid === true,
    //   style: {
    //     backgroundColor: "var(--warning)",
    //     "&:hover": { backgroundColor: "var(--warning)" },
    //   },
    // },
  ];

  componentDidMount() {
    // this.autoPopulatePanel(this.props.panelInfo); // This will be needed if there are not search panel but still needs to populate
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.query, this.props.query)) {
      this.loadGenericDataFromQuery();
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.screenId === this.props.screenId;
  }

  // autoPopulatePanel = (panel) => {
  //   //Execute start up functions (Here default actions happen at start up for example
  //   //Query received from url, automatic population

  //   var keyValues = [];
  //   if (this.props.location.search.includes("searchString=")) {
  //     var keyword = "searchString=";
  //     var searchString = this.props.location.search.substr(this.props.location.search.indexOf(keyword) + keyword.length, this.props.location.search.length);

  //     keyValues = this.getKeyValues(searchString);
  //   }

  //   if (panel.autoPopulate === true) {
  //     if (!keyValues.some((keyValue => keyValue.colName === "id")) && keyValues.length === 0 || keyValues.length === 0) {
  //       this.submitSearch(panel);
  //     }
  //     else {
  //       var runsearch = false;

  //       keyValues.forEach((keyValue, keyValue_index) => {
  //         panel.columns.forEach((col, col_index) => {
  //           if (col.tableColumn.name === keyValue.colName) {
  //             col.value = {
  //               fromValue: keyValue.value,
  //               toValue: '',
  //               orderBy: keyValue.orderBy
  //             };
  //             runsearch = true;
  //           }
  //         });
  //       });

  //       if (runsearch) {
  //         this.submitSearch();
  //       }
  //     }
  //   }
  // }

  getKeyValues = (searchString) => {
    var searchParametes = searchString.split("~");
    var keyValues = [];

    searchParametes.forEach((searchParam, searchParam_index) => {
      var pair = searchParam.split("^");
      if (pair.length > 1) {
        var keyValue = {
          colName: pair[0],
          value: pair[1],
          orderBy: pair[2]
        };
        keyValues.push(keyValue);
      }
    });

    return keyValues;
  };

  submitQuery = (row) => {
    let query = {
      screenId: this.props.screenId,
      queryOptions: [], //Todo:This should be built up dynamically from input!!!
      schema: this.props.panelInfo.table.schema,
      tableName: this.props.panelInfo.table.name
    };

    this.props.submitChildQuery(this.props.panelInfo, this.props.screenId, query, row);
  };

  loadGenericDataFromQuery = () => {
    if (_.isEmpty(this.props.query) || _.isEmpty(this.props.query.query)) {
      return;
    }
    this.setState({ isInEdit: false, isLoading: true });

    const keys = this.props.panelInfo.table.keys.filter((key) => key.primarykey === true);
    let key;

    if (keys.length > 0) key = keys[0];
    else key = "id";

    var query = {
      ...this.props.query.query,
      ...{
        panelNumber: this.props.panelInfo.panelNumber,
        panelId: this.props.panelInfo.panelNumber,
        key: key
      }
    };

    fetchGenericData(query)
      .then((response) => {
        //Todo: May need to refine the identification of errors vs success here for different error scenarios so we handle it generically
        if (!_.isEmpty(response.error)) {
          console.error("Error fetching generic data:", JSON.stringify(response.error));
          this.props.showDataFetchError(response.error.message);
          this.setState({ isLoading: false });
        } else if (response.data.success === true) {
          let data = response.data.result.data;
          this.setState(
            {
              data: _.cloneDeep(data),
              originalData: _.cloneDeep(data),
              isDirty: false,
              clearSelected: true,
              isLoading: false
            },
            () => {
              this.setState({ clearSelected: false });
              //On callback of "true" clearSelected, we reset it to false...not ideal since we're now rendering this component twice.
              //But the DataTable clearSelected seems to require a "toggle" for clearSelected to work
            }
          );
        } else {
          console.error("Error fetching generic data:", JSON.stringify(response.data));
          this.props.showDataFetchError();
          this.setState({ isLoading: false });
        }
      })
      .catch(function (error) {
        console.error("exception:", error);
        this.props.showDataFetchError(error.message);
        this.setState({ isLoading: false });
      });
  };

  linkedMenuItemSelected = (linkedPanel, row) => {
    //Todo: Verify whether something more needs to be done based on linkedPanel's linked panels and child panels.
    //Todo: It seems like maybe nothing more to be done than what's here.

		console.log(row);

    window.open(
      `${window.location.origin}${window.location.pathname}#/${linkedPanel.url}?${linkedPanel.foreignColumn}=${
        row[linkedPanel.sourceColumn]
      }`
      // , "_self" //This argument set the tab to open the URL in, to the current tab. Thus no new tab is created.
    );
  };

  linkedMenuConfirm(linkedPanel, row) {
    if (linkedPanel.confirm) {
      this.props.showAlert({
        type: "warning",
        title: "Confirm",
        content: linkedPanel.confirmMessage,
        onConfirm: () => this.linkedMenuItemSelected(linkedPanel, row),
        showCancel: true
      });
    } else {
      this.linkedMenuItemSelected(linkedPanel, row);
    }
  }

  onAddClicked = () => {
    //We create a copy of the state array, add the new row and set it to the state to re-render. (We add our new item at the start.)
    this.setState(
      (state) => {
        var parentData = {};
        if (!_.isEmpty(this.props.myInfoFromParent) && !_.isEmpty(this.props.myParentRecord)) {
          this.props.myInfoFromParent.foreignColumns.forEach((fkey, i) => {
            const pkey = this.props.myInfoFromParent.sourceColumns[i];
            parentData[fkey] = this.props.myParentRecord[pkey];
          });
        }

        //We create a new row. It will only have an id. All other values are null. User has to capture.
        let newRow = {
          id: uuidv4(),
          isInserted: true,
          ...parentData
        };

        return {
          data: [newRow, ...state.data],
          isInEdit: true,
          isDirty: true
        };
      },
      () => {
        this.selectRowForLinking(null);
      }
    );
  };

  onSaveClicked = () => {
    const key = this.state.key;
    let operations = [];

    let cloneData = _.cloneDeep(this.state.data);
    let cloneOriginalData = _.cloneDeep(this.state.originalData);

    let shouldReloadData = true;

    cloneData.forEach((rec) => {
      if (rec.isInserted === true && !(rec.isDeleted === true)) operations.push(this.insertRecord(rec));

      if (rec.isEdited === true && !(rec.isInserted === true) && !(rec.isDeleted === true)) operations.push(this.updateRecord(rec));

      if (rec.isDeleted === true && !(rec.isInserted === true)) operations.push(this.deleteRecord(rec));
    });

    if (operations.length > 0) {
      this.props.onIsLoading(true);
      Promise.all(operations)
        .then((resList) => {
          resList.forEach((res) => {
            let item = res.response;
            let record = res.record;

            switch (res.operation) {
              case "inserted": {
                if (res.success === true) {
                  let index = cloneData.findIndex((x) => x[key] === record[key]);
                  if (index >= 0) {
                    cloneData[index] = item;
                    cloneOriginalData.push(_.cloneDeep(item));
                  }

                  this.props.addToast(ToastTypes.SUCCESS, "Record inserted");
                } else {
                  shouldReloadData = false;
                  console.error("Error inserting record:", res.response);
                  this.props.addToast(ToastTypes.ERROR, "Error inserting record");
                }
                break;
              }
              case "updated": {
                if (res.success === true) {
                  let index = cloneData.indexOf(record);
                  if (index >= 0) {
                    cloneData[index] = record;
                    cloneData[index].isEdited = false;
                  }

                  index = cloneOriginalData.findIndex((x) => x[key] === record[key]);
                  if (index >= 0) {
                    cloneOriginalData[index] = _.cloneDeep(record);
                  }

                  this.props.addToast(ToastTypes.SUCCESS, "Record updated");
                } else {
                  shouldReloadData = false;
                  console.error("Error editing record:", res.response);
                  this.props.addToast(ToastTypes.ERROR, "Error updating record");
                }
                break;
              }
              case "deleted": {
                if (res.success === true) {
                  let index = cloneData.indexOf(record);
                  if (index >= 0) {
                    cloneData.splice(index, 1);
                  }

                  index = cloneOriginalData.findIndex((x) => x[key] === record[key]);
                  if (index >= 0) {
                    cloneOriginalData.splice(index, 1);
                  }

                  this.props.addToast(ToastTypes.SUCCESS, "Record deleted");
                } else {
                  shouldReloadData = false;
                  console.error("Error deleting record:", res.response);
                  this.props.addToast(ToastTypes.ERROR, "Error deleting record");
                }
                break;
              }
              default:
            }
          });
          this.props.onIsLoading(false);
        })
        .catch((erList) => {
          shouldReloadData = false;
          console.error("Error saving table data:", erList);
          this.props.addToast(ToastTypes.ERROR, "Error saving table data");
          this.props.onIsLoading(false);
        })
        .finally(() => {
          // console.log("Finally", shouldReloadData);

          if (shouldReloadData) {
            this.setState(
              {
                isInEdit: false,
                isDirty: false,
                clearSelected: true,
                data: [...cloneData],
                originalData: [...cloneOriginalData]
              },
              () => {
                this.setState({ clearSelected: false });
                this.loadGenericDataFromQuery();
                this.props.onIsLoading(false);
              }
            );
          } else {
            this.setState(
              {
                clearSelected: true,
                data: [...cloneData]
              },
              () => {
                this.setState({ clearSelected: false });
                this.props.onIsLoading(false);
              }
            );
          }
        });
    }
  };

  insertRecord = (record) => {
    return new Promise((resolve, _reject) => {
      // resolve({
      //   success: true,
      //   operation: "inserted",
      //   response: { ..._.cloneDeep(record), isInserted: false }, //response.data.result,
      //   record: record,
      // });

      insertRecord(record, this.props.screenId, this.props.panelInfo.panelNumber)
        .then((response) => {
          if (!_.isEmpty(response.error)) {
            resolve({
              success: false,
              operation: "inserted",
              response: response?.error?.response?.data
            });
          } else if (response.data.success === true)
            resolve({
              success: true,
              operation: "inserted",
              response: response.data.result,
              record: record
            });
          else
            resolve({
              success: false,
              operation: "inserted",
              response: response.data.result
            });
        })
        .catch(function (error) {
          console.log(error);
          resolve({ success: false, operation: "inserted", response: error });
        });
    });
  };

  updateRecord = (record) => {
    return new Promise((resolve, _reject) => {
      // resolve({
      //   success: true,
      //   operation: "inserted",
      //   response: { ..._.cloneDeep(record), isEdited: false }, //response.data.result,
      //   record: record,
      // });

      updateRecord(record, this.props.screenId, this.props.panelInfo.panelNumber)
        .then((response) => {
          if (!_.isEmpty(response.error))
            resolve({
              success: false,
              operation: "updated",
              response: response.error
            });
          else if (response.data.success === true) {
            resolve({
              success: true,
              operation: "updated",
              response: response.data.result,
              record: record
            });
          } else
            resolve({
              success: false,
              operation: "updated",
              response: response.data.result
            });
        })
        .catch(function (error) {
          resolve({ success: false, operation: "updated", response: error });
        });
    });
  };

  deleteRecord = (record) => {
    return new Promise((resolve, _reject) => {
      // resolve({
      //   success: true,
      //   operation: "deleted",
      //   response: _.cloneDeep(record), //response.data.result,
      //   record: record,
      // });

      deleteRecord(record, this.props.screenId, this.props.panelInfo.panelNumber)
        .then((response) => {
          if (!_.isEmpty(response.error))
            resolve({
              success: false,
              operation: "deleted",
              response: response.error
            });
          else if (response.data.success === true)
            resolve({
              success: true,
              operation: "deleted",
              response: response.data.result,
              record: record
            });
          else
            resolve({
              success: false,
              operation: "deleted",
              response: response.data.result
            });
        })
        .catch(function (error) {
          resolve({ success: false, operation: "deleted", response: error });
        });
    });
  };

  onEditClicked = () => {
    this.setState({ isInEdit: !this.state.isInEdit }, () => {
      this.selectRowForLinking(null);
    });
  };

  onUndoClicked = () => {
    this.setState(
      {
        data: _.cloneDeep(this.state.originalData),
        isInEdit: false,
        isDirty: false,
        clearSelected: true
      },
      () => {
        this.setState({ clearSelected: false });
        //On callback of "true" clearSelected, we reset it to false...not ideal since we're now rendering this component twice.
        //But the DataTable clearSelected seems to require a "toggle" for clearSelected to work
      }
    );
  };

  onRefreshClicked = () => {
    this.loadGenericDataFromQuery();
  };

  onDeleteClicked = () => {
    this.setState(
      (state) => {
        //We set our selected rows as deleted. Since tableUiSelectedRows is a reference to the actual data objects held in this.state.data,
        //we can simply set the property on the object
        state.tableUiSelectedRows.forEach((x) => (x.isDeleted = true));
        return {
          data: state.data,
          isDirty: true,
          clearSelected: true
        };
      },
      () => {
        //On callback of "true" clearSelected, we reset it to false...not ideal since we're now rendering this component twice.
        //But the DataTable clearSelected seems to require a "toggle" for clearSelected to work
        this.setState({ clearSelected: false }, () => {
          this.selectRowForLinking(null);
        });
      }
    );
  };

  onCopyClicked = () => {
    this.setState(
      (state) => {
        let newRows = [];
        state.tableUiSelectedRows.forEach((sel) => {
          newRows.push({
            ...sel,
            id: uuidv4(),
            isInserted: true,
            isDeleted: false,
            isEdited: false
          });
        });

        newRows.reverse().forEach((row) => {
          state.data.unshift(row);
        });

        return { data: state.data, isInEdit: true, isDirty: true };
      },
      () => {
        this.selectRowForLinking(null);
      }
    );
  };

  onPanelVisible = async (panelNumber) => {
    return new Promise((resolve, reject) => {
      this.props.onPanelVisible(this.props.panelInfo.panelNumber);
      resolve();
    });
  };

  onIsLoading = (isLoading) => {
    this.props.onIsLoading(isLoading);
  };

  selectRowForLinking = (row) => {
    this.setState(
      (state) => {
        if (row == null || row[state.key] === state?.linkedRow?.[state.key]) {
          return { linkedRow: null };
        } else {
          return { linkedRow: row };
        }
      },
      () => {
        if (this.state?.linkedRow != null) {
          this.onPanelVisible(this.props.panelInfo.panelNumber).then(() => {
            this.submitQuery(this.state?.linkedRow);
          });
        } else {
          this.props.onPanelHidden(this.props.panelInfo.panelNumber);
        }
      }
    );
  };

  ontableUiSelectedRowselected = (e) => {
    this.setState({ tableUiSelectedRows: e.selectedRows });
  };

  minWidthForCol = (type) => {
    const medium = "200px";
    const large = "300px";
    const xlarge = "400px";
    const normal = "170px";
    const small = "100px";
    const xsmall = "50px";
    const action = "30px";

    switch (type.toLowerCase()) {
      case "action":
        return action;
      case "boolean":
        return small;
      case "int64":
        return small;
      case "datetime":
        return normal;
      case "dropdown":
        return large;
      case "string":
        return medium;
      default:
        return normal;
    }
  };

  maxWidthForCol = (type) => {
    const medium = "600px";
    const large = "900px";
    const xlarge = "1200px";
    const normal = "500px";
    const small = "300px";
    const xsmall = "150px";
    const action = "20px";

    switch (type.toLowerCase()) {
      case "action":
        return action;
      case "boolean":
        return small;
      case "int64":
        return small;
      case "datetime":
        return normal;
      case "dropdown":
        return medium;
      case "string":
        return medium;
      default:
        return normal;
    }
  };

  handleCellChange = (val, valid, { row, col }) => {
    //Note this will be a reference to original array...be careful here...editing this directly will not re-render component.
    //But this is intended in this case.

    let findOriginalRows = this.state.originalData.filter((item) => item[this.state.key] == row[this.state.key]);

    let originalRow = findOriginalRows?.[0];
    let isEdited = false;

    if (row.isInserted !== true) {
      if (originalRow?.[col.tableColumn.name] == null) {
        isEdited = (val + "").length > 0;
      } else {
        if (col.columnType === "DateTime" || col.columnType === "short_date") {
          let date = moment(val).toDate();
          let originalDate = moment(originalRow?.[col.tableColumn.name]).toDate();

          isEdited = !(originalDate?.getTime() === date?.getTime());
        } else {
          isEdited = originalRow?.[col.tableColumn.name] != val;
        }
      }
    }

    if (val == null || (val + "").length === 0) {
      delete row[col.tableColumn.name];
    } else {
      row[col.tableColumn.name] = val; //We update the field
      row.isEdited = isEdited;
    }
  };

  _createDataTableColumn = (col) => {
    return {
      name: col.tableColumn.description,
      selector: col.tableColumn.name,
      sortable: true,
      minWidth: this.minWidthForCol(col.columnType),
      maxWidth: this.maxWidthForCol(col.columnType),
      // width: this.minWidthForCol(col.columnType),
      cellExport: (row) => row[col.tableColumn.name],
      cell: (row, index, column) => {
        let key = `${row["id"]}_${col.tableColumn.name}`;
        let editing = false;

				if(row.isDeleted === true){
					editing = false;
				} else if (isNaN(row["id"])) {
          editing = this.state.isInEdit && col.insertable; //New Record
        } else {
          editing = this.state.isInEdit && col.updateable; //Existing Record
        }
				
        const textCase = col.tableColumn.case || 2; // default to mixed case => 2

        const isRequired = !col.tableColumn.nullable && col.tableColumn.name !== "password";

        let val = "";
        if (row.hasOwnProperty(col.tableColumn.name)) {
          if (row[col.tableColumn.name] !== null) {
            val = row[col.tableColumn.name] + "";
          }
        }

        return (
          <FuseInputBox
            key={key}
            id={key}
            name={col.tableColumn.name}
            length={col.tableColumn.length}
            required={isRequired}
            type={col.columnType}
            value={val}
            editable={editing}
            disabled={!editing}
            textCase={textCase}
            maxLength={col.tableColumn.length || -1}
            dropKeyColumn="key"
            dropValueColumn="value"
            dropDownDisplayValues={col.dropDownDisplayValues}
            dropDownValues={col.dropDownValues}
            lovTable={col?.additionalSourceTable}
            lovKeyColumn={col?.additionalSourceKey}
            lovValueColumn={col?.additionalSourceValue}
            lovFilterKey={col?.additionalSourceFilter}
            lovFilterValue={row[col?.additionalSourceLookup]}
            regExp={col?.regex}
            row={row}
            col={col}
            //showErrors={true}
            onChange={this.handleCellChange}
          />
        );
      }
    };
  };

  hasAttachments = () => this.props.panelInfo.allowAttachments === true;

  hasChildPanels = () => !_.isNull(this.props.childPanels) && this.props.panelInfo.childPanels.length > 0;

  hasLinkedPanels = () => !_.isNull(this.props.linkedPanels) && this.props.panelInfo.linkedPanels.length > 0;

    getTableName = () =>
    this.props.panelInfo.table.name;

    getTableAttachments = () =>
    this.props.panelInfo.tableAttachmentsReact;


  drawTable = () => {
    let columns = this.props.panelInfo.columns.filter((x) => x.visible).map((col) => this._createDataTableColumn(col));
    console.log("Overview table name" + this.props.panelInfo.table.name);
    if (this.hasAttachments()) {
      columns.unshift({
        name: "",
        text: "",
        className: "d-flex",
        width: this.minWidthForCol("action"),
        cell: (row) => {
          return (
            <FuseAttachment
              showAsButton={false}
              sourceKey={row["attachment"]}
              tableName={this.props.panelInfo.table.name}
              attachmentMask={null}
              onUpdateSourceKey={(sourceKey) => {
                console.log("returned sourceKey - " + sourceKey);
                row["attachment"] = sourceKey;
              }}
              isInEdit={this.state.isInEdit || row.isEdited}
            />
          );
        }
      });
    }

    if ((this.hasChildPanels() || this.hasLinkedPanels()) && !this.state.isInEdit) {
      columns.unshift({
        name: "",
        text: "",
        width: this.minWidthForCol("action"),
        cell: (row) => {
          let elementChildren = [];

          if (this.hasChildPanels()) {
            const isLinked = row?.[this.state.key] === this?.state?.linkedRow?.[this.state.key];
            const iconClass = isLinked ? "fa fa-chevron-down clickable" : "fa fa-chevron-right clickable";

            elementChildren.push(
              <i
                key={0}
                className={iconClass}
                onClick={(e) => {
                  this.selectRowForLinking(row);
                }}
              />
            );
          }

          if (this.hasLinkedPanels()) {
            elementChildren.push(
              <FuseToggleDropdown key={1} dropDirection="right" title={`Row ${row[this.state.key]} Actions`} iconClasses="fa fa-link">
                {this.props.panelInfo.linkedPanels.map((x) => {
                  return (
                    <Dropdown.Item as="button" key={x.sourceColumn + '_' + x.id} onClick={(e) => this.linkedMenuConfirm(x, row)}>
                      {x.text}
                    </Dropdown.Item>
                  );
                })}
              </FuseToggleDropdown>
            );
          }

          return <div className="d-flex">{elementChildren}</div>;
        }
      });
    }

    return (
      <div>
        <FuseForm
          onSubmit={(e) => {
            this.onSaveClicked();
          }}
        >
          <FuseToolbar
            //triggers
            showSave={this.state.isInEdit || this.state.isDirty}
            showUndo={this.state.isInEdit || this.state.isDirty}
            showEdit={this.props.panelInfo.updateable && !this.state.isInEdit && this.state.data.length > 0}
            showAdd={this.props.panelInfo.insertable && true}
            showDelete={this.props.panelInfo.deletable && this.state.tableUiSelectedRows.length > 0}
            showCopy={this.props.panelInfo.insertable && this.state.tableUiSelectedRows.length > 0}
            showRefresh={!_.isEmpty(this.props.query)}
            saveDisabled={false}
            showAttachment={false}
            //handlers
            onAddClicked={this.onAddClicked}
            onCopyClicked={this.onCopyClicked}
            onSaveClicked={() => {}} //Moved to onSubmit of FuseForm
            onEditClicked={this.onEditClicked}
            onUndoClicked={this.onUndoClicked}
            onDeleteClicked={this.onDeleteClicked}
            onRefreshClicked={this.onRefreshClicked}
          />
          <div className="fuseHeader mt-2">
            <OverviewPanelSearchWrapper data={this.state.data} columns={columns} panelColumns={this.props.panelInfo.columns}>
              {(filteredItems, resetPaginationToggle, subHeaderComponentMemo) => {
                return (
                  <DataTable
                    title={this.props.panelInfo.header}
                    // subHeader={true}
                    //className='table table-responsive'
                    highlightOnHover={true}
                    //subHeaderAlign="left"
                    selectableRows={this.props.panelInfo.insertable}
                    // selectableRowsHighlight={true}
                    onSelectedRowsChange={this.ontableUiSelectedRowselected}
                    clearSelectedRows={this.state.clearSelected}
                    noDataComponent={this._renderNoData()}
                    columns={columns}
                    data={filteredItems}
                    dense={true}
                    pagination={true}
                    paginationResetDefaultPage={resetPaginationToggle} // optionally, a hook to reset pagination to page 1
                    paginationPerPage={20}
                    paginationRowsPerPageOptions={[10, 20, 50, 100]}
                    subHeader={this.state.data.length > 0}
                    subHeaderComponent={subHeaderComponentMemo}
                    noHeader={true}
                    responsive={true}
                    striped={true}
                    theme="fuseDataTableTheme"
                    customStyles={fuseDataTableCustomStyles}
                    conditionalRowStyles={this.conditionalRowStyles}
                  />
                );
              }}
            </OverviewPanelSearchWrapper>
          </div>
        </FuseForm>
      </div>
    );
  };

  _renderNoData = () => <div className="m-3 p-3">No Data</div>;

  _panelTitle = () => {
    var title = this.props.panelInfo.header;
    if (!_.isEmpty(this.props.myInfoFromParent) && !_.isEmpty(this.props.myParentRecord)) {
      title = title + ": " + this.props.myParentRecord[this.props.myInfoFromParent.descColumn];
    }
    return title;
  };

  render() {
    if (_.isEmpty(this.props.screenInfo) || _.isEmpty(this.props.screenInfo.panels)) {
      return null;
    }

    return (
      <FuseCollapsiblePanel isLoading={this.props.fetchingData || this.state.isLoading} title={this._panelTitle()}>
        {this.drawTable()}
      </FuseCollapsiblePanel>
    );
  }
}

OverviewPanelDatagrid.propTypes = {
  panelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  screenId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  location: PropTypes.any,
  onPanelVisible: PropTypes.func,
  onPanelHidden: PropTypes.func
};

const mapStateToProps = (state, ownProps) => {
  const { genericPageState } = state;
  let panelInfo =
    !_.isEmpty(state.screenInfo) && !_.isEmpty(state.screenInfo.panels)
      ? state.screenInfo.panels.filter((x) => x.id === ownProps.panelId)[0]
      : {};
  let query = !_.isEmpty(genericPageState)
    ? genericPageState.queries.filter((x) => x.screenId === ownProps.screenId && x.targetPanelNr === panelInfo.panelNumber)[0]
    : {};
  return {
    fetchingData: state.fetchingData === true,
    auth: state.auth,
    screenInfo: state.screenInfo,
    panelInfo: panelInfo,
    query: query,
    myInfoFromParent: !_.isEmpty(query) ? query.myInfoFromParent : {},
    myParentRecord: !_.isEmpty(query) ? query.myParentRecord : {}
  };
};

export default connect(
  // map state to props
  mapStateToProps,
  // map dispatch to props
  (dispatch, ownProps) => ({
    showDataFetchError: (exception) => dispatch(showDataFetchError(exception)),
    submitChildQuery: (panel, screenId, query, selectedChild) => dispatch(submitChildQuery(panel, screenId, query, selectedChild)),
    showAlert: (alertProps) => dispatch(showAlert(alertProps)),
    addToast: (type, text) => dispatch(addToastAction(type, text)) //Not including third parameter...let it default
  })
)(OverviewPanelDatagrid);
